import React from 'react'
import { Image, Pressable, StyleSheet, View } from 'react-native'
import { DS } from '@/design-system'
import { translate } from '../../i18n'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const backIcon = require('../../../assets/mainHeader/back.png')

type SettingsHeaderProps = {
  title?: string
  onBack: () => void
}

export function SettingsHeader({ title, onBack }: SettingsHeaderProps) {
  return (
    <View style={styles.header}>
      <Pressable
        onPress={onBack}
        style={styles.backButton}
        accessibilityRole="button"
        accessibilityLabel={translate('common.goBack')}
      >
        <Image source={backIcon} style={styles.backIcon} resizeMode="contain" />
      </Pressable>
      {title ? <DS.Text variant="Heading 3/Medium">{title}</DS.Text> : <View />}
      <View style={{ width: 40 }} />
    </View>
  )
}

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 8,
    height: 54
  },
  backButton: {
    padding: 8,
    width: 40
  },
  backIcon: {
    width: 24,
    height: 24
  }
})
